



































import CInternationalTelephoneInput from '~/components/shared/configurable/form/input/CInternationalTelephoneInput.vue'
import {
  computed,
  defineComponent,
  ref,
  toRefs,
  watch
} from '@nuxtjs/composition-api'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import CAppTelephoneButton from '~/components/shared/configurable/button/CAppTelephoneButton.vue'
import { TelephoneSocial } from '~/constants/telephone/social'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'

export default defineComponent({
  components: {
    FieldError,
    CAppTelephoneButton,
    CInternationalTelephoneInput
  },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = props

    const { disabled } = toRefs(props)

    const dontShowToPublic = ref(false)
    const telephone = ref({
      code: null,
      telephone: null
    })
    const viber = ref(false)
    const whatsApp = ref(false)

    const { state, getters } = useNamespacedStore<FormState>(CLASSIFIED_FORM_NS)

    function onValue(v: Ref<any>) {
      telephone.value.telephone = v.value?.telephone || null
      telephone.value.code = v.value?.code || null

      dontShowToPublic.value = v.value?.dont_show_to_public || false

      viber.value = Boolean(v.value?.social?.viber)
      whatsApp.value = Boolean(v.value?.social?.whatsapp)
    }

    const {
      error,
      isValid,
      debouncedValueChanged,
      valueChanged
    } = useClassifiedForm(props, { onValue })

    const allowNonPublic = computed(() => specs?.allow_non_public || false)
    const countries = computed(() => specs.countries)
    const selectedCountry = computed(() => state.fieldValues.location2?.country)
    const locationCountrySpecs = computed<any[]>(() => getters('countrySpecs'))

    watch(
      selectedCountry,
      (country: { id: number }, oldCountry: { id: number }) => {
        if (country?.id === oldCountry?.id || disabled.value) {
          return
        }

        const countryCode = locationCountrySpecs.value.find(
          lc => lc.id === country.id
        ).code
        const telephoneCountry = countries.value.find(
          c => c.code === countryCode
        )

        if (!telephoneCountry) {
          return
        }
        // auto change the value to reflect the change in location2 handler
        valueChanged(name, {
          code: telephoneCountry.telephone_code,
          telephone: telephone.value.telephone,
          dont_show_to_public: dontShowToPublic.value,
          social: {
            viber: Boolean(viber.value),
            whatsapp: Boolean(whatsApp.value)
          }
        })
      }
    )

    const handleTelephoneInput = (tel: any) => {
      debouncedValueChanged(name, {
        ...tel,
        dont_show_to_public: dontShowToPublic.value,
        social: {
          viber: Boolean(viber.value),
          whatsapp: Boolean(whatsApp.value)
        }
      })
    }

    const handleMiscChange = (_social: any) => {
      valueChanged(name, {
        ...telephone.value,
        dont_show_to_public: dontShowToPublic.value,
        social: {
          viber: Boolean(viber.value),
          whatsapp: Boolean(whatsApp.value)
        }
      })
    }

    return {
      dontShowToPublic,
      telephone,
      TelephoneSocial,
      viber,
      whatsApp,
      error,
      isValid,
      allowNonPublic,
      countries,
      handleTelephoneInput,
      handleMiscChange
    }
  }
})
